<template>
  <div
    class="menu-container pa-2"
    :style="{ left: `${horizontal}px`, top: `${vertical}px`, backgroundColor: 'white' }"
  >
    <div
      v-for="option in menuOptions"
      :key="option.action"
      class="d-flex align-center pa-2 menu-item"
      @click.stop="handleClick(option.action)"
    >
      <v-icon class="menu-icon">{{ option.icon }}</v-icon>
      <p class="menu-option">{{ option.label }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrayConnectionMenu",

  props: {
    horizontal: {
      type: Number,
    },
    vertical: {
      type: Number,
    },
  },

  data() {
    return {
      active: false,
      menuOptions: [
        {
          icon: 'edit',
          label: this.$i18n.t("EditFiber"),
          action: 'edit-fiber'
        },
        {
          icon: 'edit',
          label: this.$i18n.t("EditTube"),
          action: 'edit-tube'
        },
        {
          icon: 'delete',
          label: this.$i18n.t("RemoveFiber"),
          action: 'remove-fiber'
        },
        {
          icon: 'delete',
          label: this.$i18n.t("RemoveTube"),
          action: 'remove-tube'
        },
      ]
    };
  },
  computed: {

  },
  methods: {
    handleClick(action) {
      this.$emit(action)
    },
  }
}
</script>

<style scoped>
.menu-container {
  position: absolute;
  box-shadow: 1px 1px 5px rgb(88, 88, 88);
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  z-index: 1;
  min-width: 120px;
}

.menu-option {
  margin-bottom: 0px;
  margin-left: 5px;
}

.menu-icon {
  font-size: 15px !important;
  transition: none !important;
}

.menu-item {
  cursor: pointer;
  border-radius: 5px;
}

.menu-item:hover {
  color: white;
  background-color: #42A1B6;
}
.menu-item:hover .menu-icon {
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/menus/TrayConnectionMenu.vue